import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.UserPicker', {
    buttonText: 'Choose user',
    selectPlaceholderText: 'Enter the email address',
});
